import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { PopupType } from "src/app/shared/enums/popup-types";
import { EInvoiceService } from "src/app/shared/services/e-invoice.service";
import { StornoRequestDto } from "src/app/shared/types/e-invoice";
import { showMessage } from "src/app/shared/utils/toast.popup";

@Component({
  selector: "app-e-invoice-storno",
  templateUrl: "./e-invoice-storno.component.html",
  standalone: false,
})
export class EInvoiceStornoComponent implements AfterViewInit {
  @Input() billId!: number;
  @Input() invoiceId!: number;
  @Input() type!: string;
  @Output() updated: EventEmitter<void> = new EventEmitter();
  @ViewChild("stornoCommentInput") stornoCommentInput!: ElementRef;

  form: FormGroup;
  isSubmitting = false;
  public loading = false;

  constructor(private fb: FormBuilder, private eInvoiceService: EInvoiceService, public translate: TranslateService) {
    this.form = this.fb.group({
      stornoComment: ["", [Validators.required, Validators.minLength(5)]],
    });
  }

  ngAfterViewInit() {
    this.stornoCommentInput?.nativeElement.focus();
  }

  submitStorno(): void {
    if (this.form.invalid) {
      return;
    }

    this.isSubmitting = true;
    this.loading = true;

    const requestDto: StornoRequestDto = {
      invoiceId: this.invoiceId,
      stornoComment: this.form.value.stornoComment,
      planId: this.billId,
      isPayment: false,
    };
    if (this.type) {
      requestDto.type = this.type;
    }
    const subscription = this.eInvoiceService.stornoSalesInvoice(requestDto).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.loading = false;
        subscription.unsubscribe();
        this.updated.emit();
        showMessage(PopupType.Success, this.translate.instant("e-invoice.storno-success"));
      },
      error: (error) => {
        this.isSubmitting = false;
        this.loading = false;
        showMessage(PopupType.Danger, this.translate.instant("e-invoice.storno-error"), error);
        subscription.unsubscribe();
      },
    });
  }
}
